import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "******";

const SettingApiForm = () => {
  const [apiSettings, setApiSettings] = useState({
    id: null,
    netgsm_username: "",
    netgsm_password: "",
    msg_header: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchApiData();
  }, []);

  // 🔹 Yeni tabloya göre API verisini çek
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/netgsm-config`);
      console.log("Gelen Netgsm Config:", resp.data);
      const data = resp.data || {};

      if (data.netgsm_username) data.netgsm_username = MASK_VALUE;
      if (data.netgsm_password) data.netgsm_password = MASK_VALUE;

      setApiSettings(data);
    } catch (err) {
      console.error("Netgsm Config verisi çekilemedi:", err);
      toast.error("Netgsm ayarları alınamadı!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      [name]: value === MASK_VALUE ? prev[name] : value,
    }));
  };

  const handleSecretFocus = (e) => {
    if (e.target.value === MASK_VALUE) {
      e.target.value = "";
      setApiSettings((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
    }
  };

  // 🔹 Kaydetme → yeni tabloya yaz
  const handleSave = async () => {
    try {
      const sensitiveFields = ["netgsm_username", "netgsm_password"];
      const dataToSave = { ...apiSettings };

      // Maskeleri gönderme
      sensitiveFields.forEach((field) => {
        if (dataToSave[field] === MASK_VALUE) {
          delete dataToSave[field];
        }
      });

      if (dataToSave.id) {
        await axios.put(`${BASE_URL}/api/netgsm-config/${dataToSave.id}`, dataToSave);
      } else {
        await axios.post(`${BASE_URL}/api/netgsm-config`, dataToSave);
      }

      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData();
    } catch (error) {
      console.error("Netgsm Config kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label fw-bold">{getText("LABEL_NETGSM_USERNAME")}</label>
                <input
                  type="password"
                  className="form-control"
                  name="netgsm_username"
                  value={apiSettings.netgsm_username || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  placeholder={MASK_VALUE}
                  autoComplete="off"
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">{getText("LABEL_NETGSM_PASSWORD")}</label>
                <input
                  type="password"
                  className="form-control"
                  name="netgsm_password"
                  value={apiSettings.netgsm_password || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  placeholder={MASK_VALUE}
                  autoComplete="off"
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">{getText("LABEL_NETGSM_HEADER")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="msg_header"
                  value={apiSettings.msg_header || ""}
                  onChange={handleChange}
                  placeholder="Örn: KURUMADI"
                />
              </div>
              <div className="d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingApiForm;
